import { useMemo, useState } from 'preact/hooks';
import { plural } from '../format';

export type ItemSel = { id: string; rotulo: string; sub?: string };

type Props = {
  titulo: string;
  itens: ItemSel[];
  marcados: string[];
  onMudar: (ids: string[]) => void;
  /** Mostra o campo de busca (útil para listas longas, como os 223 municípios). */
  buscavel?: boolean;
  alturaMax?: number;
  erro?: string;
};

/** Lista de caixas de seleção com busca, "marcar todos os visíveis" e "limpar". */
export function SeletorLista({ titulo, itens, marcados, onMudar, buscavel, alturaMax = 200, erro }: Props) {
  const [busca, setBusca] = useState('');
  const norm = (s: string) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  const visiveis = useMemo(() => (busca ? itens.filter((i) => norm(i.rotulo).includes(norm(busca))) : itens), [itens, busca]);
  const set = useMemo(() => new Set(marcados), [marcados]);

  const alternar = (id: string) => onMudar(set.has(id) ? marcados.filter((x) => x !== id) : [...marcados, id]);
  const marcarVisiveis = () => onMudar([...new Set([...marcados, ...visiveis.map((i) => i.id)])]);

  return (
    <fieldset class="seletor">
      <legend>{titulo} <small>({plural(marcados.length, 'selecionado', 'selecionados')})</small></legend>
      {buscavel && (
        <div class="seletor-topo">
          <input type="search" placeholder="Filtrar…" value={busca} onInput={(e) => setBusca(e.currentTarget.value)} aria-label={`Filtrar ${titulo}`} />
          <button type="button" class="link" onClick={marcarVisiveis}>Marcar {busca ? 'os filtrados' : 'todos'}</button>
          <button type="button" class="link" onClick={() => onMudar([])}>Limpar</button>
        </div>
      )}
      <div class="seletor-lista" style={{ maxHeight: `${alturaMax}px` }}>
        {visiveis.map((i) => (
          <label key={i.id} class="check">
            <input type="checkbox" checked={set.has(i.id)} onChange={() => alternar(i.id)} /> {i.rotulo}
            {i.sub && <small> · {i.sub}</small>}
          </label>
        ))}
        {visiveis.length === 0 && <p class="vazio">Nada encontrado.</p>}
      </div>
      {erro && <small class="erro" role="alert">{erro}</small>}
    </fieldset>
  );
}
